import { render, staticRenderFns } from "./t-products.vue?vue&type=template&id=44c234ab&scoped=true&"
import script from "./t-products.vue?vue&type=script&lang=js&"
export * from "./t-products.vue?vue&type=script&lang=js&"
import style0 from "./t-products.vue?vue&type=style&index=0&id=44c234ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c234ab",
  null
  
)

export default component.exports